import 'firebaseui/dist/firebaseui.css'
import './featureSelection'
import './index.css'
import AppContainer from './AppContainer'
import React from 'react'
import ReactDOM from 'react-dom'

ReactDOM.render(<AppContainer />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js